var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#14AE5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04848 7.52675L7.64986 11.4895C7.4972 11.922 7.08839 12.2113 6.62971 12.2113H4.72121C4.3229 12.2113 4 11.8884 4 11.4901C4 11.0918 4.3229 10.7689 4.72121 10.7689H6.37458L8.19836 5.60147C8.48141 4.7995 9.61556 4.79952 9.8986 5.60147L13.3758 15.4534L14.7744 11.4906C14.927 11.0581 15.3359 10.7689 15.7945 10.7689H17.703C18.1013 10.7689 18.4242 11.0918 18.4242 11.4901C18.4242 11.8884 18.1013 12.2113 17.703 12.2113H16.0497L14.2259 17.3787C13.9428 18.1806 12.8087 18.1806 12.5256 17.3787L9.04848 7.52675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignType);
export default __webpack_public_path__ + "static/media/campaign-type.bec95d6e1aebca6a0a9aec34aebdf7c5.svg";
export { ForwardRef as ReactComponent };